import React from "react";
import { Slide, SlideProps } from "@mui/material";

export const OcTransition = React.forwardRef<HTMLDivElement, SlideProps>(
  function OcTransition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  },
);

OcTransition.displayName = "OcTransition";

export default OcTransition;
